
import img0 from './FileClassificationRule.png';
import img1 from './FileProtectionRule.png';
  
const content = `# File Classification and Protection Rules

OnData SecureFile can be configured to automate the discovery, classification, and protection of sensitive files. Please refer to the 
[**SecureFile Settings**](reference_doc#how-to_guides/securefile/securefile_settings) on how to configure the auto discovery settings and other SecureFile related settings. The automated file 
classification and protection are driven by the file classification rules and file protection rules. This page illustrates how to configure the file 
classification rules and file protection rules.  
  
## 1. File Classification Rules
  
Below are the steps on how to create a file classification rule:  
a. Login to the OnData Portal and navigate to \`Settings -> SecureFile -> Classification and Protection\`  
b. Click on the \`File Classification Rules\`, then click on the \`Create Rule\` button on the top  
c. Provide a \`Name\`, select a \`Target Classification\`, and enter a \`Description\`. The \`Target Classification\` is what a file will be classified as if this rule is 
applied for this file based on the rule priority and rule definition as detailed below  
d. Select a \`Priority\` for this rule. The rule priorities determine the sequence of applying the file classification rules when multiple rules exist. The rules with 
the highest priority (Priority 1) are applied first  
e. Keep the default status of the rule as \`Active\`  
f. Follow the steps in \`Section 3 - Rule Definition\` below on how to configure the rule definition  
g. Click on the \`Save\` button to create the file classification rule  
  
![Create File Classification Rule](${ img0 })  
  
## 2. File Protection Rules
  
Below are the steps on how to create a file protection rule:  
a. Login to the OnData Portal and navigate to \`Settings -> SecureFile -> Classification and Protection\`  
b. Click on \`File Protection Rules\`, and click on the \`Create Rule\` button on the top  
c. Provide a \`Rule Name\`, and enter a \`Description\`  
d. Follow the steps in \`Section 3 - Rule Definition\` below on how to configure the rule definition. Any file meeting the rule definition criteria will be automatically 
encrypted and protected by SecureFile    
e. Click on the \`Save\` button to create the file protection rule  
  
![Create File Protection Rule](${ img1 })  
  
## 3. Rule Definition
  
The criteria for automated classification and protection are defined in \`Rule Definition\`. A \`Rule Definition\` contains a group of \`AND\` and \`OR\` clauses that determines 
whether a rule is applicable to a file or not. Such clauses may contain nest subgroups of \`AND\` and \`OR\` clauses.  

Each clause is defined in the format of: <File Attribute> <Operator> <Value>. For example, the \`Document Type\` \`Equals\` "W-9 Form". You can select any of the file 
attributes below:  
a. \`File Name\`: the name of a file  
b. \`File Path\`: the path of a file  
c. \`File Extension\`: the file extension of a file  
d. \`Computer\`: the computer name where a file is located  
e. \`Document Type\`: the Document Type of a file. Please refer to the [**Document Types**](reference_doc#how-to_guides/securefile/document_types) for more details  
f. \`Info Type\`: the Info Type that a file contains. Please refer to the [**File Information Types**](reference_doc#how-to_guides/securefile/file_information_types) for more details  
  
And you can select any of following operators:  
a. \`Equals\`: this operator will perform an "equal" comparison with a single value  
b. \`Contains\`: this operator will perform a substring comparison with a single value  
c. \`Matches\`: this operator will assume the value is a regular expression and perform a string match  
d. \`Equals Any\`: this operator will perform an "equal" comparison with a list of values  
e. \`Matches Any\`: this operator will perform a string match with a list of regular expressions  

When the file attribute is \`Info Type\`, only the \`Equals\` and \`Equals Any\` operators are supported.  
  

`
  
export default content;
